var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4C9.37256 4 3.99998 9.37259 3.99998 16C3.99998 22.6274 9.37256 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37259 22.6274 4 16 4ZM1.33331 16C1.33331 7.89983 7.8998 1.33334 16 1.33334C24.1002 1.33334 30.6666 7.89983 30.6666 16C30.6666 24.1002 24.1002 30.6667 16 30.6667C7.8998 30.6667 1.33331 24.1002 1.33331 16Z",
    fill: "#47525D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9428 11.0572C21.4635 11.5779 21.4635 12.4221 20.9428 12.9428L12.9428 20.9428C12.4221 21.4635 11.5779 21.4635 11.0572 20.9428C10.5365 20.4221 10.5365 19.5779 11.0572 19.0572L19.0572 11.0572C19.5779 10.5365 20.4221 10.5365 20.9428 11.0572Z",
    fill: "#47525D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0572 11.0572C11.5779 10.5365 12.4221 10.5365 12.9428 11.0572L20.9428 19.0572C21.4635 19.5779 21.4635 20.4221 20.9428 20.9428C20.4221 21.4635 19.5779 21.4635 19.0572 20.9428L11.0572 12.9428C10.5365 12.4221 10.5365 11.5779 11.0572 11.0572Z",
    fill: "#47525D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.ebb19a73c5b38c3347f01875864fa93f.svg";
export { ForwardRef as ReactComponent };